import { AlertCircle, Clock, Send } from 'lucide-react';
import { cn } from '../lib/cn';

// Badge stato SDI per le righe di lista (chiave = invoices.sdi_status normalizzato dal backend).
// In overview "andata allo SDI" è uno stato unico ("Inviata SDI"): non distinguiamo
// sent/accepted. Restano distinti solo gli stati-problema (scartata/errore) e i transitori.
const SDI_BADGE_CONFIG: Record<string, { label: string; cls: string; Icon: typeof Send }> = {
  waiting: { label: 'In coda SDI', cls: 'bg-yellow-100 text-yellow-800 border-yellow-300', Icon: Clock },
  quarantena: { label: 'In coda SDI', cls: 'bg-yellow-100 text-yellow-800 border-yellow-300', Icon: Clock },
  sent: { label: 'Inviata SDI', cls: 'bg-blue-100 text-blue-800 border-blue-300', Icon: Send },
  accepted: { label: 'Inviata SDI', cls: 'bg-blue-100 text-blue-800 border-blue-300', Icon: Send },
  rejected: { label: 'Scartata', cls: 'bg-red-100 text-red-800 border-red-300', Icon: AlertCircle },
  'invoice-error': { label: 'Errore SDI', cls: 'bg-red-100 text-red-800 border-red-300', Icon: AlertCircle },
};

const NOT_SENT = { label: 'Non inviata SDI', cls: 'bg-gray-100 text-gray-600 border-gray-300', Icon: Send };

type Props = {
  sdiStatus: string | null | undefined;
  sdiUuid: string | null | undefined;
};

export function SdiStatusBadge({ sdiStatus, sdiUuid }: Props) {
  const cfg = (sdiStatus && SDI_BADGE_CONFIG[sdiStatus]) || (sdiUuid ? SDI_BADGE_CONFIG.sent : null) || NOT_SENT;
  const Ic = cfg.Icon;
  return (
    <span
      title={cfg.label}
      className={cn('inline-flex items-center gap-1 px-2 py-1 rounded-full border text-[11px] font-semibold whitespace-nowrap', cfg.cls)}
    >
      <Ic className="w-3 h-3" />
      {cfg.label}
    </span>
  );
}
